import React, { useState } from 'react';
import NavigationBar from '../../components/layout/Navbar';
import { useResumenMes, usePlanOperativo } from './hooks/usePlanOperativo';

const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
               'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

export default function ResumenMes() {
  const hoy = new Date();
  const [anio,       setAnio]       = useState(hoy.getFullYear());
  const [mes,        setMes]        = useState(hoy.getMonth() + 1);
  const [tab,        setTab]        = useState('lista');
  const [fincaFiltro, setFincaFiltro] = useState(null);

  const { contexto } = usePlanOperativo();
  const esAdmin = contexto?.esAdmin;

  const idCpEfectivo = esAdmin ? fincaFiltro : null;
  const { registros, resumen, cargando, error } = useResumenMes(anio, mes, idCpEfectivo);

  const nombreFinca = esAdmin
    ? (fincaFiltro
        ? (contexto?.fincas?.find(f => f.id === fincaFiltro)?.nombre || '')
        : 'Todas las fincas')
    : (contexto?.finca?.nombre || '');

  const cambiarMes = (delta) => {
    let nm = mes + delta, na = anio;
    if (nm > 12) { nm = 1;  na++; }
    if (nm < 1)  { nm = 12; na--; }
    setMes(nm); setAnio(na);
  };

  return (
    <>
      <NavigationBar />
      <main style={s.main}>

        {/* Cabecera */}
        <div style={s.header}>
          <div style={s.logoBox}>📋</div>
          <div>
            <h1 style={s.h1}>Resumen Operativo — {nombreFinca}</h1>
            <p style={s.sub}>Registros y resumen mensual</p>
          </div>
        </div>

        {/* Navegación mes */}
        <div style={s.navRow}>
          <button style={s.navBtn} onClick={() => cambiarMes(-1)}>‹</button>
          <span style={s.mesTitulo}>{MESES[mes - 1]} {anio}</span>
          <button style={s.navBtn} onClick={() => cambiarMes(1)}>›</button>
        </div>

        {/* Selector de finca (solo Admin) */}
        {esAdmin && contexto?.fincas && (
          <div style={s.filtroRow}>
            <label style={s.filtroLabel}>Finca:</label>
            <select
              style={s.filtroSelect}
              value={fincaFiltro ?? ''}
              onChange={e => setFincaFiltro(e.target.value ? Number(e.target.value) : null)}
            >
              <option value="">Todas las fincas</option>
              {contexto.fincas.map(f => (
                <option key={f.id} value={f.id}>{f.nombre}</option>
              ))}
            </select>
          </div>
        )}

        {error && <div style={s.errorBox}>⚠️ {error}</div>}
        {cargando && <div style={s.loadingTxt}>Cargando...</div>}

        {/* Tabs */}
        <div style={s.tabs}>
          <button style={{ ...s.tab, ...(tab === 'lista'   ? s.tabActive : {}) }} onClick={() => setTab('lista')}>
            📋 Registros ({registros.length})
          </button>
          <button style={{ ...s.tab, ...(tab === 'resumen' ? s.tabActive : {}) }} onClick={() => setTab('resumen')}>
            📊 Resumen mensual
          </button>
        </div>

        {/* TAB 1 — Lista de registros */}
        {tab === 'lista' && (
          <div style={s.card}>
            {registros.length === 0 && !cargando ? (
              <div style={s.empty}>Sin registros para {MESES[mes - 1]} {anio}</div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={s.table}>
                  <thead>
                    <tr style={s.thead}>
                      <th style={s.th}>Fecha</th>
                      {esAdmin && <th style={s.th}>Finca</th>}
                      <th style={s.th}>Actividad</th>
                      <th style={s.th}>Sección</th>
                      <th style={s.thNum}>Jornales</th>
                      <th style={s.thNum}>Campo</th>
                      <th style={s.thNum}>Cont.</th>
                      <th style={s.thNum}>Incap.</th>
                      <th style={s.thNum}>Perm.</th>
                      <th style={s.th}>Observaciones</th>
                      <th style={s.th}>Registrado por</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registros.map(r => (
                      <tr key={r.id} style={s.tr}>
                        <td style={s.tdFecha}>{formatFecha(r.fecha)}</td>
                        {esAdmin && <td style={s.td}><span style={s.fincaBadge}>{r.finca_nombre}</span></td>}
                        <td style={s.tdAct}>{r.actividad_nombre}</td>
                        <td style={s.td}>{r.seccion_nombre}</td>
                        <td style={s.tdNum}>{r.jornales_ejecutados}</td>
                        <td style={s.tdNum}>{r.operarios_campo || '—'}</td>
                        <td style={s.tdNum}>{r.contratistas    || '—'}</td>
                        <td style={s.tdNum}>{r.incapacitados   || '—'}</td>
                        <td style={s.tdNum}>{r.permisos        || '—'}</td>
                        <td style={s.tdObs}>{r.observaciones || ''}</td>
                        <td style={s.td}>{r.registrado_por || ''}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* TAB 2 — Resumen mensual */}
        {tab === 'resumen' && resumen && (
          <div>
            {/* Tarjetas de personal */}
            <div style={s.cards}>
              <Tarjeta label="Jornales ejecutados" valor={resumen.personal?.total_jornales     ?? 0} color="#1D9E75" />
              <Tarjeta label="Días trabajados"      valor={resumen.personal?.dias_trabajados    ?? 0} color="#185FA5" />
              <Tarjeta label="Operarios en campo"   valor={resumen.personal?.total_operarios    ?? 0} color="#639922" />
              <Tarjeta label="Contratistas"         valor={resumen.personal?.total_contratistas ?? 0} color="#BA7517" />
              <Tarjeta label="Incapacitados"        valor={resumen.personal?.total_incapacitados ?? 0} color="#993556" />
              <Tarjeta label="Permisos"             valor={resumen.personal?.total_permisos     ?? 0} color="#888780" />
            </div>

            {/* Tabla plan vs ejecutado */}
            <div style={s.card}>
              <h3 style={s.sectionTitle}>Plan vs Ejecutado por actividad</h3>
              {resumen.jornales?.length === 0 ? (
                <div style={s.empty}>Sin datos de ejecución para este mes</div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={s.table}>
                    <thead>
                      <tr style={s.thead}>
                        <th style={s.th}>Actividad</th>
                        <th style={s.thNum}>Planeado</th>
                        <th style={s.thNum}>Ejecutado</th>
                        <th style={s.thNum}>Diferencia</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(resumen.jornales || []).map((j, i) => {
                        const diff = Number(j.diferencia);
                        return (
                          <tr key={i} style={s.tr}>
                            <td style={s.tdAct}>
                              <span style={{ ...s.dot, background: j.color_hex || '#1D9E75' }} />
                              {j.actividad}
                            </td>
                            <td style={s.tdNum}>{j.jornales_planeados}</td>
                            <td style={s.tdNum}>{j.jornales_ejecutados}</td>
                            <td style={{ ...s.tdNum, color: diff >= 0 ? '#1D9E75' : '#DC2626', fontWeight: 600 }}>
                              {diff >= 0 ? '+' : ''}{diff}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        )}

        {tab === 'resumen' && !resumen && !cargando && (
          <div style={s.card}>
            <div style={s.empty}>Sin datos para {MESES[mes - 1]} {anio}</div>
          </div>
        )}

      </main>
    </>
  );
}

function Tarjeta({ label, valor, color }) {
  return (
    <div style={{ ...s.tarjeta, borderTop: `3px solid ${color}` }}>
      <p style={{ ...s.tarjetaNum, color }}>{valor}</p>
      <p style={s.tarjetaLabel}>{label}</p>
    </div>
  );
}

function formatFecha(fechaStr) {
  if (!fechaStr) return '';
  const f = fechaStr.slice(0, 10);
  const [y, m, d] = f.split('-');
  return `${d}/${m}/${y}`;
}

const s = {
  main:        { fontFamily: 'sans-serif', padding: '1rem', maxWidth: 1100, margin: '0 auto', width: '100%' },
  header:      { display: 'flex', alignItems: 'center', gap: 12, marginBottom: '1rem' },
  logoBox:     { width: 44, height: 44, fontSize: 24, background: '#E1F5EE', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  h1:          { margin: 0, fontSize: 18, fontWeight: 600, color: '#0F6E56' },
  sub:         { margin: 0, fontSize: 13, color: '#666' },
  navRow:      { display: 'flex', alignItems: 'center', gap: 12, marginBottom: '1rem' },
  navBtn:      { width: 32, height: 32, border: '1px solid #ccc', borderRadius: 8, background: '#fff', cursor: 'pointer', fontSize: 18 },
  mesTitulo:   { fontSize: 17, fontWeight: 600, minWidth: 180, textAlign: 'center' },
  errorBox:    { background: '#FFF3CD', border: '1px solid #FBBF24', borderRadius: 8, padding: '10px 14px', marginBottom: '1rem', fontSize: 13, color: '#92400E' },
  loadingTxt:  { textAlign: 'center', padding: '0.5rem', fontSize: 13, color: '#888', marginBottom: '0.5rem' },
  tabs:        { display: 'flex', borderBottom: '2px solid #eee', marginBottom: '1rem' },
  tab:         { padding: '10px 20px', fontSize: 14, cursor: 'pointer', background: 'none', border: 'none', borderBottom: '3px solid transparent', color: '#888', fontWeight: 500, marginBottom: -2 },
  tabActive:   { color: '#0F6E56', borderBottomColor: '#1D9E75' },
  card:        { background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: '1rem', marginBottom: '1rem' },
  empty:       { textAlign: 'center', padding: '2rem', color: '#aaa', fontSize: 14 },
  table:       { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  thead:       { background: '#f5f5f5' },
  th:          { padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#444', borderBottom: '1px solid #e5e5e5', whiteSpace: 'nowrap' },
  thNum:       { padding: '10px 12px', textAlign: 'center', fontWeight: 600, color: '#444', borderBottom: '1px solid #e5e5e5', whiteSpace: 'nowrap' },
  tr:          { borderBottom: '1px solid #f0f0f0' },
  td:          { padding: '9px 12px', color: '#333', verticalAlign: 'middle' },
  tdFecha:     { padding: '9px 12px', color: '#555', whiteSpace: 'nowrap', fontWeight: 500 },
  tdAct:       { padding: '9px 12px', color: '#222', fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6 },
  tdNum:       { padding: '9px 12px', textAlign: 'center', color: '#333' },
  tdObs:       { padding: '9px 12px', color: '#777', fontSize: 12, maxWidth: 200 },
  fincaBadge:  { background: '#555', color: '#fff', fontSize: 11, padding: '2px 8px', borderRadius: 6, whiteSpace: 'nowrap' },
  dot:         { width: 10, height: 10, borderRadius: 3, display: 'inline-block', flexShrink: 0 },
  cards:       { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 12, marginBottom: '1rem' },
  tarjeta:     { background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: '1rem', textAlign: 'center' },
  tarjetaNum:  { fontSize: 28, fontWeight: 700, margin: '0 0 4px' },
  tarjetaLabel:{ fontSize: 12, color: '#666', margin: 0 },
  sectionTitle:{ fontSize: 15, fontWeight: 600, color: '#333', marginTop: 0, marginBottom: 12 },
  filtroRow:   { display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1rem' },
  filtroLabel: { fontSize: 13, fontWeight: 600, color: '#444', whiteSpace: 'nowrap' },
  filtroSelect:{ fontSize: 13, padding: '6px 10px', borderRadius: 8, border: '1px solid #ccc', background: '#fff', minWidth: 200, cursor: 'pointer' },
};
